export default __webpack_public_path__ + "static/media/health.b1c8f3da.svg";